import type { FC } from "react";

import classNames from "classnames";

import { LockOutlineCloseIcon } from "@jti/brand-icons/lock-outline-close";
import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { Skeleton } from "@jti/core-components/components/Skeleton";

import styles from "./TiersStatuses.module.scss";

const SKELETON_ROWS_COUNT = 3;

export type TierItemProps = {
  tierName: string;
  pointsRange: string;
  isAchieved: boolean;
};

export type TiersStatusesProps = {
  items?: TierItemProps[];
  isLoading?: boolean;
};

export const TiersStatuses: FC<TiersStatusesProps> = ({ items, isLoading }) => {
  if (isLoading) {
    return (
      <div className={styles.tiersStatuses} data-testid="tiers-statuses-loading">
        {Array.from({ length: SKELETON_ROWS_COUNT }, (_value, index) => (
          <div className={classNames(styles.tierItem, styles.tierItemSkeleton)} key={index}>
            <Skeleton height="1lh" />
          </div>
        ))}
      </div>
    );
  }

  if (!items?.length) return null;
  return (
    <div className={styles.tiersStatuses}>
      {items.map(({ tierName, pointsRange, isAchieved }) => {
        return (
          <div
            className={classNames(styles.tierItem, {
              [styles.active]: isAchieved,
            })}
            key={tierName}
            data-testid={`tier-${tierName}`}
          >
            <p className={styles.tierName}>{tierName}</p>
            <p className={styles.pointsRange}>{pointsRange}</p>
            {isAchieved ? (
              <UiCheckIcon className={styles.icon} />
            ) : (
              <LockOutlineCloseIcon className={classNames(styles.icon, styles.iconLocked)} />
            )}
          </div>
        );
      })}
    </div>
  );
};
